var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.562 6.92802V13.0729C18.562 14.0791 18.0229 15.0135 17.1515 15.5256L11.8151 18.607C10.9436 19.1101 9.86558 19.1101 8.98516 18.607L3.64875 15.5256C2.77731 15.0225 2.23828 14.0881 2.23828 13.0729V6.92802C2.23828 5.92182 2.77731 4.98746 3.64875 4.47538L8.98516 1.39392C9.8566 0.890827 10.9347 0.890827 11.8151 1.39392L17.1515 4.47538C18.0229 4.98746 18.562 5.91284 18.562 6.92802Z",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4018 9.1015C11.5579 9.1015 12.4951 8.16431 12.4951 7.00824C12.4951 5.85218 11.5579 4.91504 10.4018 4.91504C9.24577 4.91504 8.30859 5.85218 8.30859 7.00824C8.30859 8.16431 9.24577 9.1015 10.4018 9.1015Z",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9957 14.1865C13.9957 12.5694 12.3876 11.2578 10.4021 11.2578C8.41671 11.2578 6.80859 12.5694 6.80859 14.1865",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.69559f178e8aff67cabe0c02fa15fd7b.svg";
export { ForwardRef as ReactComponent };